import { Injectable, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "./app-config.service";

export interface User {
  username: string;
  companyid: string;
  companyname: string;
  userinfo: string;
  userid: string;
  password: string;
  domain: string;
  domainusername: string;
  domainpassword: string;
  remember: boolean;
  usertype: string;
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(
    private router: Router,
    private http: HttpClient,
    private appConfig: AppConfigService,
  ) {}

  private get apiUrl(): string {
    return this.appConfig.apiUrl;
  }

  private diller = [
    { id: 1, name: "tr-TR", label: "TR" },
    { id: 2, name: "en-US", label: "EN" },
  ];
  private aktifDil = new BehaviorSubject<any>(this.getInitialDil());
  getAktifDil = this.aktifDil.asObservable();
  public loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  // public username: BehaviorSubject<any> = new BehaviorSubject<any>('');
  private username = new BehaviorSubject<string | null>(
    JSON.parse(sessionStorage.getItem("username") || "null"),
  );
  private usertype = new BehaviorSubject<string | null>(
    JSON.parse(sessionStorage.getItem("usertype") || "null"),
  );
  private companyname = new BehaviorSubject<string | null>(
    JSON.parse(sessionStorage.getItem("companyname") || "null"),
  );
  private userinfo = new BehaviorSubject<string | null>(
    JSON.parse(sessionStorage.getItem("userinfo") || "null"),
  );
  usrData = [];

  getUserName = this.username.asObservable();
  getFirmName = this.companyname.asObservable();
  getUserInfo = this.userinfo.asObservable();
  getUserType = this.usertype.asObservable();
  get isLoggedIn() {
    // this.loggedIn.next(true);
    return this.loggedIn.asObservable();
  }

  // get getUserName() {
  //   this.username.next(JSON.parse(sessionStorage.getItem('username')!));
  //   return this.username.asObservable();
  // }

  // get getFirmName() {
  //   this.companyname.next(JSON.parse(sessionStorage.getItem('companyname')!));
  //   return this.companyname.asObservable();
  // }

  // get getUserInfo() {
  //   this.userinfo.next(JSON.parse(sessionStorage.getItem('userinfo')!));
  //   return this.userinfo.asObservable();
  // }

  // set setUserType(type) {
  //   sessionStorage.setItem('userType', JSON.stringify(type));
  //   this.userType.next(type);
  //   // return this.userType.asObservable();
  // }

  // get getUserType() {
  //   this.usertype.next(JSON.parse(sessionStorage.getItem('usertype')!));
  //   return this.usertype.asObservable();
  // }

  setDil(dilId: number): void {
    const secilenDil = this.diller.find((d) => d.id === dilId);
    if (secilenDil) {
      localStorage.setItem("language", JSON.stringify(secilenDil));
      this.aktifDil.next(secilenDil); // Değişikliği tüm uygulamaya duyurur
    }
  }

  getDil() {
    const kayitliDil = localStorage.getItem("language");
    return kayitliDil ? JSON.parse(kayitliDil) : null;
  }

  getDillerListesi() {
    return this.diller;
  }

  private getInitialDil() {
    const kayitliDil = this.getDil();
    // Eğer localStorage boşsa varsayılan olarak listedeki ilk dili (tr-TR) döner
    return kayitliDil ? kayitliDil : this.diller[0];
  }

  setObserveable(user: any) {
    this.loggedIn.next(true);
    this.usertype.next(user.usertype);
    this.username.next(user.username);
    this.companyname.next(user.companyname);
    this.userinfo.next(user.userinfo);
    this.router.navigate(["/main/summary"]);
  }

  logout() {
    sessionStorage.removeItem("userinfo");
    sessionStorage.removeItem("usertype");
    sessionStorage.removeItem("userid");
    sessionStorage.removeItem("username");
    sessionStorage.removeItem("domainusername");
    sessionStorage.removeItem("companyid");
    sessionStorage.removeItem("companyname");
    sessionStorage.removeItem("token");

    this.loggedIn.next(false);
    this.username.next("");
    this.companyname.next("");
    this.userinfo.next("");
    this.router.navigate(["/login"]);
    // this.router.navigateByUrl('/login');
    // window.location.reload();
  }

  resendPassword() {
    // sessionStorage.removeItem('userName');
    // sessionStorage.removeItem('firmName');
    // sessionStorage.removeItem('userInfo');
    // // sessionStorage.removeItem('userType');
    // this.loggedIn.next(false);
    // this.userName.next('');
    this.router.navigate(["/reset"]);
    // this.router.navigateByUrl('/login');
    // window.location.reload();
  }

  delegation() {
    // sessionStorage.removeItem('userName');
    // sessionStorage.removeItem('firmName');
    // sessionStorage.removeItem('userInfo');
    // // sessionStorage.removeItem('userType');
    // this.loggedIn.next(false);
    // this.userName.next('');
    this.router.navigate(["/delegation"]);
    // this.router.navigateByUrl('/login');
    // window.location.reload();
  }

  getToken(): string | null {
    return sessionStorage.getItem("token");
  }

  poolLogin(obj: any) {
    console.log(this.apiUrl + "api/auth/login");
    return this.http.post(this.apiUrl + "api/auth/login", obj);
  }

  getSecureLogin(user: string) {
    console.log(this.apiUrl + "api/auth/login/secure/" + user);
    return this.http.get(this.apiUrl + "api/auth/login/secure/" + user);
  }
  // user?: string, type?: string
  getPoolAuth(): Observable<any> {
    console.log(this.apiUrl + "api/auth");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!))
      .set("userType", JSON.parse(sessionStorage.getItem("usertype")!));
    return this.http.get(this.apiUrl + "api/auth", { params: queryParams });
  }
  // user: any
  getDocumentAuth(): Observable<any> {
    console.log(this.apiUrl + "api/auth/doc");
    const queryParams = new HttpParams()
      .set("companyId", JSON.parse(sessionStorage.getItem("companyid")!))
      .set("user", JSON.parse(sessionStorage.getItem("username")!));
    return this.http.get(this.apiUrl + "api/auth/doc", { params: queryParams });
  }

  getDocumentTypes(user: any) {
    console.log(this.apiUrl + "api/auth/doc/types/" + user);
    return this.http.get(this.apiUrl + "api/auth/doc/types/" + user);
  }

  forgotPassword(obj: any) {
    console.log(this.apiUrl + "api/auth/forgot-password");
    return this.http.post(this.apiUrl + "api/auth/forgot-password", obj);
  }

  resetPassword(obj: any) {
    console.log(this.apiUrl + "api/auth/forgot-password");
    return this.http.post(this.apiUrl + "api/auth/reset-password", obj);
  }
}
